var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c(_vm.activeBlogMod,{tag:"component",attrs:{"blogKeys":_vm.blogKeys,"blogs":_vm.blogs,"editObj":_vm.editObj}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }